import { useCallback, useEffect } from "react";
import Mousetrap from "mousetrap";
import { useCanvasPos, useCanvasStore } from "@/store/zustand/canvasStore";
import { useActiveCanvas } from "@/utils/utils";

// Function to find the nearest power of 2
const nearestPowerOf2 = (number) => {
  return Math.pow(2, Math.round(Math.log(number) / Math.log(2)));
};

const useZoomControls = () => {
  const activeCanvas = useActiveCanvas();

  const { zoomPerc } = useCanvasPos();
  const setCanvasPosValue = useCanvasStore((state) => state.setCanvasPosValue);

  // Zoom In
  const zoomIn = useCallback(() => {
    // @ts-expect-error TS18048
    const newZoom = nearestPowerOf2(zoomPerc * 2 * 128) / 128;
    // @ts-expect-error TS18047
    setCanvasPosValue(activeCanvas.id, { zoomPerc: newZoom });
  }, [activeCanvas?.id, zoomPerc]);

  // Zoom Out
  const zoomOut = useCallback(() => {
    // @ts-expect-error TS18048
    const newZoom = nearestPowerOf2((zoomPerc / 2) * 128) / 128;
    // @ts-expect-error TS18047
    setCanvasPosValue(activeCanvas.id, { zoomPerc: newZoom });
  }, [activeCanvas?.id, zoomPerc]);

  // Zoom Reset
  const zoomReset = useCallback(() => {
    // @ts-expect-error TS18047
    setCanvasPosValue(activeCanvas.id, { zoomPerc: 1 });
  }, [activeCanvas?.id]);

  // Handle keyboard shortcuts
  useEffect(() => {
    const handleZoom = (e, zoomAction) => {
      if (e.preventDefault) e.preventDefault();
      else e.returnValue = false; // For Internet Explorer

      zoomAction();
    };

    Mousetrap.bind("meta+=", (e) => handleZoom(e, zoomIn));
    Mousetrap.bind("meta+-", (e) => handleZoom(e, zoomOut));
    Mousetrap.bind("meta+0", (e) => handleZoom(e, zoomReset));

    return () => {
      Mousetrap.unbind("meta+=");
      Mousetrap.unbind("meta+-");
      Mousetrap.unbind("meta+0");
    };
  }, [zoomPerc]);

  return { zoomIn, zoomOut, zoomReset };
};

export default useZoomControls;
